<template>
  <div class="d-flex justify-center align-center">
    <v-img
      class="ma-auto"
      style="object-fit: cover;"
      max-height="30%"
      max-width="30%"
      src="@/assets/coloring_logo.png"
    ></v-img>
  </div>
</template>

<script>
export default {
  data() {
    return {
      snackbars: [],
      multiLine: false,
      text: "This is a snackbar!",
    };
  },
  methods: {
    addSnackbar() {
      this.snackbars.push({
        show: true,
        multiLine: this.multiLine,
        text: this.text,
      });
    },
    removeSnackbar(index) {
      this.snackbars.splice(index, 1);
    },
  },
};
</script>
